<template>
  <v-app>
    <div style="display: contents">
      <v-card
        flat
        width="100%"
        height="100%"
        class="d-flex justify-center align-center"
      >
        <v-card flat class="rounded-lg" width="400">
          <v-card-title class="pa-0">
            <v-form ref="form" class="px-4" style="width: 100%">
              <v-card-title class="justify-center align-center py-0">
                <img src="@/assets/img/logo-survey.png" width="18%" />
                <v-toolbar-title
                  ><span
                    class="font-weight-bold"
                    style="color: #2d9ed7; font-size: 28px"
                    >Survey</span
                  ><span
                    class="font-weight-bold"
                    style="color: #f251a8; font-size: 28px"
                    >Me</span
                  ></v-toolbar-title
                >
              </v-card-title>
              <form>
                <v-row class="justify-center" no-gutters>
                  <v-col
                    cols="12"
                    md="10"
                    align="start"
                    class="py-2"
                    style="font-size: 16px"
                  >
                    <span>ลงทะเบียน</span>
                  </v-col>
                  <v-col class="txtcol" cols="12" md="10">
                    <v-text-field
                      label="ชื่อผู้ใช้"
                      outlined
                      dense
                      class="rounded-lg"
                      color="#2B9DD7"
                      v-model="register.username"
                      :rules="DuplicatedUsername"
                    >
                      <v-icon
                        outlined
                        slot="prepend-inner"
                        class="mr-3"
                        color="#2B9DD7"
                        >account_circle</v-icon
                      >
                    </v-text-field>
                  </v-col>
                  <v-col class="txtcol" cols="12" md="10">
                    <v-text-field
                      label="รหัสผ่าน"
                      v-model="register.password"
                      outlined
                      dense
                      :type="!show1 ? 'password' : 'text'"
                      class="rounded-lg"
                      color="#2B9DD7"
                      :rules="PasswordRules"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show1 = !show1"
                    >
                      <v-icon
                        outlined
                        slot="prepend-inner"
                        class="mr-3"
                        color="#2B9DD7"
                        >lock</v-icon
                      >
                    </v-text-field>
                  </v-col>
                  <v-col class="txtcol" cols="12" md="10">
                    <v-text-field
                      label="ยืนยันรหัสผ่าน"
                      v-model="confirmpassword"
                      outlined
                      dense
                      :type="!show2 ? 'password' : 'text'"
                      class="rounded-lg"
                      color="#2B9DD7"
                      :rules="ConfirmPasswordRules"
                      :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show2 = !show2"
                    >
                      <v-icon
                        outlined
                        slot="prepend-inner"
                        class="mr-3"
                        color="#2B9DD7"
                        >lock</v-icon
                      >
                    </v-text-field>
                  </v-col>
                  <v-col class="txtcol" cols="12" md="10">
                    <v-text-field
                      label="ชื่อ"
                      outlined
                      dense
                      class="rounded-lg"
                      color="#2B9DD7"
                      v-model="register.firstname"
                      :rules="[$store.getters.TextRule(register.firstname)]"
                    >
                      <v-icon
                        outlined
                        slot="prepend-inner"
                        class="mr-3"
                        color="#2B9DD7"
                        >mdi-contacts</v-icon
                      >
                    </v-text-field>
                  </v-col>
                  <v-col class="txtcol" cols="12" md="10">
                    <v-text-field
                      label="นามสกุล"
                      outlined
                      dense
                      class="rounded-lg"
                      color="#2B9DD7"
                      v-model="register.surname"
                      :rules="[$store.getters.TextRule(register.surname)]"
                    >
                      <v-icon
                        outlined
                        slot="prepend-inner"
                        class="mr-3"
                        color="#2B9DD7"
                        >mdi-contacts</v-icon
                      >
                    </v-text-field>
                  </v-col>
                  <v-col class="txtcol" cols="12" md="10">
                    <v-text-field
                      label="เบอร์ติดต่อ"
                      outlined
                      dense
                      class="rounded-lg"
                      color="#2B9DD7"
                      counter="10"
                      maxlength="10"
                      v-model="register.contactNumber"
                      :rules="phoneRequiredFormat"
                    >
                      <v-icon
                        outlined
                        slot="prepend-inner"
                        class="mr-3"
                        color="#2B9DD7"
                        >account_circle</v-icon
                      >
                    </v-text-field>
                  </v-col>
                  <v-col class="txtcol" cols="12" md="10">
                    <v-checkbox
                      v-model="consent"
                      color="#2B9DD7"
                      hide-details
                      class="mt-0 my-5"
                    >
                      <template #label>
                        <span style="font-size: 13px; word-break: break-word"
                          >รับทราบ
                          <a
                            class="text-decoration-underline"
                            target="_blank"
                            href="https://chatme04.chatme.co.th/CMStorage/landing/policy/Terms_and_Conditions_09022024_202402121356.pdf"
                            @click.stop
                            >ข้อตกลงและเงื่อนไขการใช้บริการ</a
                          > และ <a
                            target="_blank"
                            href="https://chatme04.chatme.co.th/CMStorage/landing/policy/Data_Protection_Policy_for_Customers_and_Clients.pdf"
                            @click.stop
                            >นโยบายคุ้มครองข้อมูลส่วนบุคคล</a
                          >
                        </span>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="10">
                    <v-btn
                      class="white--text rounded-lg"
                      color="#2B9DD7"
                      width="100%"
                      dense
                      :disabled="!consent"
                      @click="RegisterSubmit"
                    >
                      ลงทะเบียน
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    md="10"
                    align="center"
                    class="pt-2"
                    style="font-size: 14px"
                  >
                    <span style="color: rgba(0, 0, 0, 0.6)"
                      >มีบัญชีผู้ใช้อยู่แล้ว ?</span
                    >
                    <span
                      class="pl-4 text-decoration-underline"
                      style="color: #2b9dd7; cursor: pointer"
                      @click="
                        $router.push({
                          path: '/',
                        })
                      "
                      >เข้าสู่ระบบ</span
                    >
                  </v-col>
                </v-row>
              </form>
            </v-form>
          </v-card-title>
        </v-card>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import axios from "axios";
import _ from "lodash";
export default {
  data: () => ({
    register: {
      firstname: "",
      surname: "",
      username: "",
      password: "",
      contactNumber: "",
    },
    show1: false,
    show2: false,
    confirmpassword: "",
    duplicated: false,
    consent: false,
  }),
  created: function () {
    this.debouncedCheckUsername = _.debounce(this.CheckUsername, 1000);
  },
  computed: {
    MobileSize() {
      const { xs } = this.$vuetify.breakpoint;
      return xs ? true : false;
    },
    DuplicatedUsername() {
      const rules = [];
      if (typeof this.register.username !== "object") {
        if (this.register.username.length <= 0) {
          rules.push("กรุณากรอกข้อมูล");
        } else if (
          this.register.username.indexOf(" ") > 0 ||
          this.register.username.charAt(0) === " "
        ) {
          rules.push("ไม่อนุญาตให้ใส่ช่องว่างได้");
        } else if (this.register.username.length <= 3) {
          rules.push("กรุณากรอกอย่างน้อย 3 หลัก");
        } else if (!/^[A-Za-z\d]+$/.test(this.register.username)) {
          rules.push(
            "กรุณากรอกข้อมูลเป็นภาษาอังกฤษหรือตัวเลขเท่านั้น (ผสมภาษาอังกฤษและตัวเลขได้)"
          );
        }
      } else {
        rules.push("กรุณากรอกข้อมูลอย่างน้อย 3 หลัก");
      }
      this.debouncedCheckUsername();
      if (this.duplicated) {
        rules.push("Username ซ้ำ");
      }
      return rules;
    },
    PasswordRules() {
      const rules = [];
      if (typeof this.register.password !== "object") {
        if (this.register.password.length <= 0) {
          rules.push("กรุณากรอกข้อมูล");
        } else if (
          this.register.password.indexOf(" ") > 0 ||
          this.register.password.charAt(0) === " "
        ) {
          rules.push("ไม่อนุญาตให้ใส่ช่องว่างได้");
        }
        // else if ((!/[A-Z]/.test(this.register.password.charAt(0)))||(!/[a-z]/.test(this.register.password.charAt(1)) && !/[A-Z]/.test(this.register.password.charAt(1)))) {
        //   rules.push(`กรุณากรอกอักษร 2 ตัวแรกเป็นภาษาอังกฤษโดยตัวแรกเป็นพิมพ์ใหญ่ เช่น Aa, Ba`);
        // }
        else if (this.register.password.length <= 2) {
          rules.push("กรุณากรอกอย่างน้อย 3 หลัก");
        } else if (this.register.password.length > this.max) {
          rules.push(`คุณกรอกเกิน ${this.max} หลัก`);
        }
      } else {
        rules.push("กรุณากรอกข้อมูลอย่างน้อย 3 หลัก");
      }
      return rules;
    },
    ConfirmPasswordRules() {
      const rules = [];
      if (typeof this.confirmpassword !== "object") {
        if (this.confirmpassword.length <= 0) {
          rules.push("กรุณากรอกข้อมูล");
        } else if (
          this.confirmpassword.indexOf(" ") > 0 ||
          this.confirmpassword.charAt(0) === " "
        ) {
          rules.push("ไม่อนุญาตให้ใส่ช่องว่างได้");
        } else if (this.confirmpassword.length <= 2) {
          rules.push("กรุณากรอกอย่างน้อย 3 หลัก");
        } else if (this.confirmpassword.length > this.max) {
          rules.push(`คุณกรอกเกิน ${this.max} หลัก`);
        } else if (this.confirmpassword !== this.register.password) {
          rules.push("Password ไม่ตรงกัน");
        }
      } else {
        rules.push("กรุณากรอกข้อมูลอย่างน้อย 3 หลัก");
      }
      return rules;
    },
    phoneRequiredFormat() {
      const rules = [];
      if (typeof this.register.contactNumber != "object") {
        if (this.register.contactNumber.length <= 0) {
          rules.push("กรุณากรอกเบอร์โทรศัพท์");
        } else if (this.register.contactNumber.charAt(0) != "0") {
          rules.push("รูปแบบเบอร์โทรศัพท์ของคุณไม่ถูกต้อง");
        } else if (this.register.contactNumber.charAt(1) == "0") {
          rules.push("รูปแบบเบอร์โทรศัพท์ของคุณไม่ถูกต้อง");
        } else if (
          this.register.contactNumber.length != 10 &&
          this.register.contactNumber.length != 9
        ) {
          rules.push("กรุณากรอกให้ครบ 9 หลัก หรือ 10 หลัก");
        } else if (!/^[0-9]+$/.test(this.register.contactNumber)) {
          rules.push("กรุณากรอกข้อมูลเป็นตัวเลขเท่านั้น");
        }
      } else {
        rules.push("กรุณากรอกเบอร์โทรศัพท์");
      }
      return rules;
    },
  },
  methods: {
    toterms() {
      let routeData = this.$router.resolve({ name: "terms" });
      window.open(routeData.href, "_blank");
    },
    CheckUsername: function () {
      if (this.register.username) {
        axios
          .get(
            `${process.env.VUE_APP_API_DOMAIN}/CMUser/auth/checkChatmeUser/${this.register.username}`
          )
          .then((req) => {
            this.duplicated = !req.data.userStatus;
          });
      }
    },
    RegisterSubmit() {
      if (this.$refs.form.validate()) {
        axios
          .post(
            process.env.VUE_APP_API_DOMAIN + "/CMUser/auth/register",
            this.register
          )
          .then((req) => {
            this.$store.commit("Login", req.data.accessToken);
            this.$cookies.set(
              process.env.VUE_APP_CM_AUTH_COOKIE + "_username",
              this.register.username
            );
            this.$emit("logged");
            this.$router.push({
              name: "survey",
            });
          })
          .catch(() => {});
      }
    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: "MitrRegular";
  src: url("~@/assets/font/MitrRegular/MitrRegular.ttf");
}
#app {
  font-family: "MitrRegular" !important;
}
.v-input >>> .v-label--active {
  left: -40px !important;
}
</style>
